import { render, staticRenderFns } from "./NotesList.vue?vue&type=template&id=20cf0356"
import script from "./NotesList.vue?vue&type=script&lang=ts"
export * from "./NotesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports